import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../../helpers/constants";
import {useTranslation} from "react-i18next";
import {ALERTS} from "../../../locales/components/namespaces";
import useUserData from "../../../hooks/user/useUserData";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import useUserAction from "../../../hooks/user/useUserAction";

const useType = () => {
    const {t} = useTranslation(ALERTS)
    const {token, isLoggedIn} = useUserData()
    const {userLogout} = useUserAction()
    const [loading, setLoading] = useState(false)
    const [type, setType] = useState([])
    const [updateType, setUpdateType] = useState(false)

    useEffect(() => {
        setLoading(true)
        axios({
            method: 'get',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/loan/type/list`,
        }).then((response) => {
            setType(response.data)
            setLoading(false)

        }).catch(error => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to get loan types list.'), {
                    variant: 'error'
                }
            ))
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }, [updateType])

    return {
        loading,
        type
    }
}

export default useType
